const trainColorDot = "#94CAE0";
const testColorDot = "#E57873";
const testColorBar = testColorDot;
const trainColorBar = trainColorDot;
const lineColor = "green";

export { testColorBar, trainColorBar, trainColorDot, testColorDot, lineColor };
